import React from "react";
import { HStack, Spacer, Tag } from "@chakra-ui/react";
import { format, parseISO } from "date-fns";
import { DigitalSignature, Form, Wrapper } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { hooks } from "./duck";

const Agreement: React.FC = () => {
  const { calculationAgreement, procedureDate } = useCurrentCase(
    medicalCase => ({
      calculationAgreement:
        medicalCase.data.client.patient.calculationAgreement,
      procedureDate: medicalCase.data.client.patient.procedureDate
    })
  );
  const { dateFormat } = useOrganizationSettings();

  const update = hooks.useUpdateAgreement(calculationAgreement?._id as number);
  const defaultValues = React.useMemo(
    () => ({
      signature: calculationAgreement?.file || null,
      signedAt: calculationAgreement?.signedAt
    }),
    [calculationAgreement]
  );

  return (
    <Wrapper>
      <Form defaultValues={defaultValues}>
        <Form.Watcher onChange={update as any} defaultValues={defaultValues} />
        <HStack spacing={4} mb={6}>
          <Spacer />
          <Tag color="gray.600" bgColor="gray.200">
            {format(
              parseISO(calculationAgreement?.signedAt || procedureDate),
              dateFormat
            )}
          </Tag>
          {/* TODO create editable tag for date*/}
          {calculationAgreement?.signedAt && (
            <Tag color="gray.600" bgColor="gray.200">
              {format(parseISO(calculationAgreement.signedAt), "h:mm aaaa")}
            </Tag>
          )}
        </HStack>
        <DigitalSignature name="signature" label="Doctor’s Signature" />
      </Form>
    </Wrapper>
  );
};

export default Agreement;
